import React, { Fragment, useState } from 'react';
import Message from './Message';
import Progress from './Progress';
import axios from 'axios';

const FileUpload = ({ parentCallback, ...props }) => {

  const location = window.location.pathname;

  const [file, setFile] = useState('');
  const [filename, setFilename] = useState('---');
  const [uploadedFile, setUploadedFile] = useState({});
  const [message, setMessage] = useState('');
  const [uploadPercentage, setUploadPercentage] = useState(0);

  const onChange = e => {
    if(e.target.files[0]){
      if (!e.target.files[0].name.match(/.(jpg|jpeg|png)$/i)) {
        setFile(null);
        if (location === "/en/") {
          setMessage('The file is not an image or the file format is not allowed.');
        } else if (location === "/de/") {
          setMessage('Die Datei ist kein Bild oder das Dateiformat ist nicht zulässig.');
        } else {
          setMessage('Plik nie jest zdjęciem lub format pliku nie jest dozwolony.');
        }
      } else {
        setFile(e.target.files[0]);
        setFilename(e.target.files[0].name);
      }
    }
  };

  const onSubmit = async e => {
    e.preventDefault();

    const formData = new FormData();
    formData.append('file', file);

    try {
      const res = await axios.post('http://95.216.218.0:4000/uploads', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: progressEvent => {
          setUploadPercentage(
            parseInt(
              Math.round((progressEvent.loaded * 100) / progressEvent.total)
            )
          );
          // Clear percentage
          setTimeout(() => setUploadPercentage(0), 5000);
        },
      });


      const { fileName, filePath } = res.data;

      setUploadedFile(
        { fileName, filePath },
      );

      if (location === "/en/") {
        setMessage('Graphic added correctly.');
      } else if (location === "/de/") {
        setMessage('Grafik korrekt hinzugefügt.');
      } else {
        setMessage('Grafika dodana.');
      }

      const newValue = filePath;
      parentCallback(newValue);

    } catch (err) {
      if (err.response.status === 500) {
        if (location === "/en/") {
          setMessage('An error occurred, please try again in a moment.');
        } else if (location === "/de/") {
          setMessage('Ein Fehler ist aufgetreten. Bitte versuchen Sie es gleich erneut.');
        } else {
          setMessage('Wystąpił błąd, spróbuj ponownie za chwilę.');
        }
        setUploadedFile();
      } else if (err.response.status === 413) {
        if (location === "/en/") {
          setMessage('The file is too big, maximum size is 1MB, try again in a moment. ');
        } else if (location === "/de/") {
          setMessage('Die Datei ist zu groß, maximal 1 MB. Bitte versuchen Sie es gleich erneut.');
        } else {
          setMessage('Plik jest za duży, maksymalnie 1MB, spróbuj ponownie za chwilę.');
        }
        setUploadedFile();
      } else {
        setMessage(err.response.data.msg);
        setUploadedFile();
      }
    }
  };

  return (
    <Fragment>
      {message ? <Message msg={message} /> : null}
      <form className="image__uploadForm" onSubmit={onSubmit}>

        <div className='image__upload'>
          <input
            type='file'
            className='input__uploadFile'
            id={props.id}
            accept="image/*"
            onChange={onChange}
          />
          <label className='input__uploadFile--label' htmlFor={props.id}>
            {filename}
          </label>
          <Progress percentage={uploadPercentage} />
        </div>
        {!file ? (
          null
        ) :
        <input
          type='submit'
          value={location === "/en/" && 'Upload' || location === "/de/" && "Hochladen" || location ==="/" && "Wgraj"}
          />
        }
        <div className="alert">Jpg, jpeg, png - max 1MB.</div>

      </form>
    </Fragment>
  );
};

export default FileUpload;

